import { Component, OnInit } from '@angular/core';
import { BaseTableService } from 'src/app/services/base-table.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-base-add',
  templateUrl: './base-add.component.html',
  styleUrls: ['./base-add.component.scss']
})
export class BaseAddComponent<T> implements OnInit {

  isSending = false;
  isLoading = true;
  service: BaseTableService<any>;
  serviceGoogle: GoogleStorageService;
  item: T;
  pathUrlList = '';
  configFields = [];
  isUploadingFile = {};

  constructor(
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) { }

  ngOnInit(): void {
    this.searchFormByParams();
  }

  onClickSave() {
    if (!this.isValidRequiredParams()) {
      return;
    }

    this.isSending = true;
    this.service.save(this.item).toPromise().then(data => {
      this.isSending = false;
      if (!data.success) {
          this.alertService.showError('Error!', data.error.message);
          return;
        }
      this.alertService.showSuccess('Exito!', 'Se ha creado correctamente!.');
      this.navigator.navigateByUrl('/' + this.pathUrlList);
    }).catch(error => {
      this.isSending = false;
      const message = (error && error.error && error.error.message)
        || (error && error.message)
        || 'Ocurrió un error inesperado. Intente nuevamente.';
      this.alertService.showError('Error!', message);
    });
  }

  searchFormByParams() {
    // Buscar ID del tour
    this.route.params.subscribe(params => {
      if (params.id) {
        this.loadItem(params.id);
      } else {
        this.configIfNew();
        this.isLoading = false;
      }
    });
  }

  loadItem(itemId: number) {
    this.isLoading = true;
    this.service.fetch(itemId).toPromise().then(data => {
      if (!data.success) {
        this.navigator.navigateByUrl('/' + this.pathUrlList);
      }
      this.item = data.response;
      this.isLoading = false;
    });
  }

  isValidRequiredParams(): boolean {
    // Recorremos todos los campos
    for (const field of this.configFields) {
      if (field.required) {
        if (this.item[field.key] == '') {
          this.alertService.showError('Error!', 'El campo ' + field.title + ' es requerido!');
          return false;
        }
      }
    }
    return true;
  }

  configIfNew() {}

  onUploadFiles(files, field, item) {
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      this.onUploadFile(element, field, item);
    }
  }

  onUploadFile(file, field, item) {
    this.isUploadingFile[field.key] = true;
    this.serviceGoogle.upload(file).toPromise().then(data => {
      this.isUploadingFile[field.key] = false;
      if (!data.success) {
        return;
      }
      
      item[field.key] = data.response.url;
    });
  }

  onRemovePhotoInGallery(photo, field, item) {
    let index = item[field.key].indexOf(photo);
    if (index > -1) {
      item[field.key].splice(index, 1);
    }
  }

  onUploadInGallery(files, field, item) {
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      this.onUploadGalleryPhoto(element, field, item);
    }
  }

  onUploadGalleryPhoto(file, field, item) {
    this.isUploadingFile[field.key] = true;
    this.serviceGoogle.upload(file).toPromise().then(data => {
      this.isUploadingFile[field.key] = false;
      if (!data.success) {
        return;
      }
      
      if (item[field.key] == undefined) {
        item[field.key] = [];
      }

      item[field.key].push({
        'name': data.response.name,
        'url': data.response.url,
        'alt': ''
      });

    });
  }
}
